// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type SupportAgent24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const SupportAgent24: FC<SupportAgent24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <path d="M11 21v-2h8v-7.1q0-2.925-2.038-4.962T12 4.9 7.038 6.937 5 11.9V18H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 16v-2q0-.525.263-.988.262-.462.737-.737l.075-1.325a8.7 8.7 0 0 1 .987-3.15 9.5 9.5 0 0 1 1.975-2.525A8.8 8.8 0 0 1 8.763 3.6Q10.3 3 12 3t3.225.6 2.725 1.663a9 9 0 0 1 1.975 2.512q.775 1.45 1 3.15l.075 1.3q.475.225.738.675.262.45.262.95v2.3q0 .5-.262.95t-.738.675V19q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm-2-7a.97.97 0 0 1-.713-.287A.97.97 0 0 1 8 13q0-.424.287-.713A.97.97 0 0 1 9 12q.424 0 .713.287.287.288.287.713 0 .424-.287.713A.97.97 0 0 1 9 14m6 0a.97.97 0 0 1-.713-.287A.97.97 0 0 1 14 13q0-.424.287-.713A.97.97 0 0 1 15 12q.424 0 .713.287.287.288.287.713 0 .424-.287.713A.97.97 0 0 1 15 14m-8.975-1.55Q5.85 9.8 7.625 7.9 9.399 6 12.05 6q2.224 0 3.912 1.412Q17.65 8.826 18 11.026A7.9 7.9 0 0 1 13.813 9.8a7.97 7.97 0 0 1-2.938-3.25 8 8 0 0 1-1.687 3.563 8 8 0 0 1-3.163 2.337" />
        </svg>
    );
};

export default SupportAgent24;
